export default __webpack_public_path__ + "static/media/croptop-medium-front.29a86466.jpg";